import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
  response: null,
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
};

export const addRole = createAsyncThunk(
  'roles/addrole',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.post('/api/userRoles', udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let data = response.data;
      // console.log(data)
      if (response.status === 200) {
        return data;
      }
      else if (response.status === 201) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const addRoleSlice = createSlice({
  name: 'addrole',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateAddRole: (state, { payload }) => {
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
    },
    isSuccess: (state, { payload }) => {
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isSuccess = false;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {
    [addRole.fulfilled]: (state, { payload }) => {
      // console.log(payload)
      state.response = payload;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [addRole.pending]: (state) => {
      state.isFetching = true;
    },
    [addRole.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    }
  },
});

export const { clearStateAddRole, isSuccess } = addRoleSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateAddRole());
  }
}

export function clearStateSuccess() {

  return async (dispatch) => {
    dispatch(isSuccess());
  }
}

export const addRoleSelector = (state) => state.addrole;

export default addRoleSlice.reducer;
